<template>
  <div>
    <!-- 塾検索フォーム -->
    <v-customer-search-form />

    <v-container class="py-0" fluid v-if="isSearched">
      <!-- 塾情報 -->
      <v-form
        ref="customer-form"
        :value="customerValid"
        lazy-validation
      >
        <v-request-customer-form/>
      </v-form>

      <!-- 登録済教室一覧 -->
      <v-registered-classroom-table/>

    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import VCustomerSearchForm from '@/components/molecules/CustomerSearchForm'
import VRegisteredClassroomTable from '@/components/molecules/RegisteredClassroomTable'
import VRequestCustomerForm from '@/components/organizms/RequestCustomerForm'

export default {
  components: {
    VCustomerSearchForm,
    VRegisteredClassroomTable,
    VRequestCustomerForm,
  },


  props: {},

  computed: {
    ...mapState('enrollment',[
      'customerValid',
      'classrooms',
      'classroomValid',
    ]),
    ...mapGetters('enrollment',[
      'isSearched',
    ]),
  },

  methods: {
    ...mapMutations('enrollment', [
      'setCustomerPayload',
      'setRegisteredClassrooms',
      'addClassroom',
    ]),
  },
}
</script>

<style lang="stylus" scoped>

.list-th
  font-size: 13px !important
  padding: 0 35px !important
  background-color: #e5e5e5 !important

.list-td
  padding: 0 35px !important

.search-th
  width 100px
  height 20px
  background-color #3b7cab
  text-align center
  color #fff
  font-size 13px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

.form-th
  width 30%
  height 30px
  background-color #3b7cab
  text-align left
  color #fff
  font-size 14px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

.form-td
  width 1500px
  background-color #fff1f8
  border 1px solid white

.text-field
  width 200px
  margin 10px
  min-height 10px
  background-color white
  &__file
    width 400px
    margin 10px
    min-height 10px


.attention
  font-size 12px
  margin-bottom 5px

.hint
  font-size 11px
  color #252525
  margin-bottom 5px

.tooltip__text
  font-weight bold

.question
  font-size 16px
  text-shadow 0px 1px white
  color #ff4a3d !important
</style>
